export default {
  instagram: /instagram.com\/([\w\.]+)/,
  youtube: /youtube.com\/ch?a?n?n?e?l?\/([\w-]+)/,
  tiktok: /tiktok.com\/@([\w\.]+)/,
}
